export default "__VITE_ASSET__7e49ZT$m__"